import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import Experiences from './pages/Experiences';
import Events from './pages/Events';
import PlanYourTrip from './pages/PlanYourTrip';
import Destinations from './pages/Destinations';
import ProfileMenuProvider from './pages/ProfileMenuProvider';
import ProfileMenuPreApprovedProvider from './pages/ProfileMenuPreApprovedProvider';
import ProfileMenuVisitor from './pages/ProfileMenuVisitor';
import MainLayout from './layouts/MainLayout';
import NotFoundPage from './pages/NotFoundPage'; // Optional: extract 404 page
import {useEffect, useState} from 'react';
import { AuthProvider } from './Auth';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'; 
import Amenities from './pages/Amenities';
import AboutPieria from './pages/AboutPieria';
import ManageRequests from './components/Admin/ManageRequests';
import ManageEvents from './components/Admin/ManageEvents';
import ManageUsers from './components/Admin/ManageUsers';
import ManageProviders from './components/Admin/ManageProviders';
import ManageAmenities from './components/Admin/ManageAmenities';
import ManageDestinations from './components/Admin/ManageDestinations';
import ManageExperiences from './components/Admin/ManageExperiences';
import AdminDashboard from './components/Admin/AdminDashboard';
import AddDestination from './components/Admin/AddDestination';
import EditDestination from './components/Admin/EditDestination';
import AddExperience from './components/Admin/AddExperience';
import EditExperience from './components/Admin/EditExperience';
import AddEvent from './components/Admin/AddEvent';
import EditEvent from './components/Admin/EditEvent';
import AddAmenity from './components/Admin/AddAmenity';
import EditAmenity from './components/Admin/EditAmenity';
import AboutPieriaInfo from './components/Admin/AboutPieriaInfo';
import AllCategoriesAdmin from './components/Admin/AllCategoriesAdmin';
import AddCategory from './components/Admin/Categories/AddCategory';
import EditCategory from './components/Admin/Categories/EditCategory';
import ProtectedRoute from './components/ProtectedRoute';
import ContactInfo from './pages/ContactInfo';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteAccount from './pages/DeleteAccount';

function App() {

  const [userType, setUserType] = useState("");

  useEffect(() => {
    const type =  sessionStorage.getItem("userRole");
    setUserType(type);
  }, []);

  // // let userType = "admin";
  // let userType = " ";

  return (
    <Routes>
        
      {/* <Route element={<MainLayout/>}> */}
        {/* <Route path="/" element={<Home />} /> */}

        {/* <Route
          path="/"
          element={
            userType === "admin" ? (
              <AdminDashboard/>
            ) : (
              <Home />
            )
          }
        /> */}

      <Route element={<MainLayout />}>
        <Route
          path="/"
          element={userType === "Admin" ? <AdminDashboard /> : <Home />}
        />

        <Route
          path="/register-signIn"
          element={
            <AuthProvider>
              <ToastContainer />
              <SignIn />
            </AuthProvider>
          }
        />


        <Route path="/register-signIn" element={ <AuthProvider>
                                                   <ToastContainer />
                                                   <SignIn />
                                                 </AuthProvider>} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/about-pieria" element={<AboutPieria />} />
        <Route path="/amenities" element={<Amenities/>} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/event-calendar" element={<Events />} />
        <Route path="/plan-your-trip" element={<PlanYourTrip />} />
        <Route path="/contact-information" element={<ContactInfo/>} />
        <Route path="/terms-of-use" element={<TermsOfUse/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/delete-account" element={<DeleteAccount />} />

        {/* <Route path="/profile-menu-provider" element={<ProfileMenuProvider />} /> */}

       <Route
         path="/profile-menu-provider"
         element={
           <ProtectedRoute allowedRoles={["Provider"]}>
             <ProfileMenuProvider />
           </ProtectedRoute>
         }
       />

       <Route
         path="/profile-menu-pre-approved-provider"
         element={
           <ProtectedRoute allowedRoles={[ "PreApprovedProvider"]}>
             <ProfileMenuPreApprovedProvider />
           </ProtectedRoute>
         }
       />


        {/* <Route path="/profile-menu-visitor" element={<ProfileMenuVisitor />} /> */}
         <Route
           path="/profile-menu-visitor"
           element={
             <ProtectedRoute allowedRoles={["RegisteredUser"]}>
               <ProfileMenuVisitor />
             </ProtectedRoute>
           }
         />

   
        <Route path="*" element={<NotFoundPage />} />


           {/* ✅ Protected Admin Routes */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <ManageUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/providers"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <ManageProviders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/destinations"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <ManageDestinations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/add-destination"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AddDestination />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit-destination/:id"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <EditDestination />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/experiences"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <ManageExperiences />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/add-experience"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AddExperience />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit-experience/:id"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <EditExperience />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <ManageEvents />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/add-event"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AddEvent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit-event/:id"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <EditEvent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/amenities"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <ManageAmenities />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/add-amenity"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AddAmenity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit-amenity/:id"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <EditAmenity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/requests"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <ManageRequests />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/about-pieria"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AboutPieriaInfo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/all-categories-admin"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AllCategoriesAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/add-new-category/:categoryType"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AddCategory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit-category/:categoryType/:id"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <EditCategory />
            </ProtectedRoute>
          }
        />
      {/* </Route> */}
     

        {/* Admin routes — still under same layout
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<ManageUsers />} />
        <Route path="/admin/providers" element={<ManageProviders />} />
        <Route path="/admin/destinations" element={<ManageDestinations />} />
        <Route path="/admin/add-destination" element={<AddDestination/>} />
        <Route path="/admin/edit-destination/:id" element={<EditDestination />} />
        <Route path="/admin/experiences" element={<ManageExperiences />} />
        <Route path="/admin/add-experience" element={<AddExperience/>} />
        <Route path="/admin/edit-experience/:id" element={<EditExperience />} />
        <Route path="/admin/events" element={<ManageEvents />} />
        <Route path="/admin/add-event" element={<AddEvent/>} />
        <Route path="/admin/edit-event/:id" element={<EditEvent />} />
        <Route path="/admin/amenities" element={<ManageAmenities />} />
        <Route path="/admin/add-amenity" element={<AddAmenity/>} />
        <Route path="/admin/edit-amenity/:id" element={<EditAmenity />} />
        <Route path="/admin/requests" element={<ManageRequests />} />
        <Route path="/admin/about-pieria" element={<AboutPieriaInfo />} />
        <Route path="/admin/all-categories-admin" element={<AllCategoriesAdmin />} />
        <Route path="/admin/add-new-category/:categoryType" element={<AddCategory />} />
        <Route path="/admin/edit-category/:categoryType/:id" element={<EditCategory />} /> */}

        {/* Fallback */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
